import React from 'react'

export const GrupoScreen = ({ state, setState }) => {
    const handdlelabelClick = ({ target }) => {
        const chk = target.parentNode.childNodes[0];
        if (chk !== undefined && chk !== null) {
            target.parentNode.firstChild.click();
        }
    }
    return (
        <div className='form-check agrupador'>
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    // id="exampleRadios1"
                    value="option2"
                    id='chkSucursal'
                    onChange={() => setState({ ...state, activo: 'S' })}
                />
                <label class="form-check-label" for="exampleRadios1" onClick={handdlelabelClick}>
                    Sucursal
                </label>
            </div>
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    // id="exampleRadios1"
                    value="option1"
                    id='chkRegion'
                    onChange={(e) => setState({ ...state, activo: 'R' })}
                />
                <label class="form-check-label" for="exampleRadios1"
                    onClick={handdlelabelClick}>
                    ADR
                </label>
            </div>
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    // id="exampleRadios1"
                    value="option1"
                    id='chkConsolidado'
                    defaultChecked={true}
                    onChange={(e) => setState({ ...state, activo: 'C' })}
                />
                <label class="form-check-label" for="exampleRadios1"
                    onClick={handdlelabelClick}>
                    Consolidado
                </label>
            </div>
        </div>

    )
}
